<template>
  <!-- 退款单请求 -->
  <div class="refundRequest">
    <!-- 面包屑导航 -->
    <crumbs-bar
      @refresh="handleRefresh"
      :crumbsList="['订单管理', $route.meta.title]"
    >
      <template slot="controls">
        <el-button type="primary" v-if="buttonVisibility.export" icon="el-icon-download" @click="handleExport"
          >导出退货单</el-button
        >
      </template>
    </crumbs-bar>
    <!-- 搜索框 -->
    <search-bar>
      <template>
        <label class="label">订单状态：</label>
        <el-select
          placeholder="订单状态"
          style="width: 100px; margin-right: 5px"
          v-model="searchForm.status"
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-input
          style="width: 200px; margin-right: 5px"
          clearable
          placeholder="输入原始单号/单位名称"
          v-model="searchForm.name"
        >
        </el-input>
        <el-button type="primary"
          icon="el-icon-search"   
          @click="seach" 
          v-if="buttonVisibility.search"
        >搜索</el-button
        >
      </template>
    </search-bar>
    <!-- 数据展示 -->
    <el-table
      :data="tableData"
      stripe
      border
      height="calc(100% - 130px)"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column label="序号" align="center" width="50">
        <template slot-scope="scope">
          <span>{{ (currPage - 1) * pageSize + scope.$index + 1 }}</span>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="Lsh"
        show-overflow-tooltip
        label="退款单号"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="orderTime"
        align="center"
        show-overflow-tooltip
        label="发起时间"
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="businessname"
        label="单位名称"
        align="center"
        show-overflow-tooltip
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="OrderNo"
        label="原始单号"
        align="center"
        show-overflow-tooltip
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="Amount"
        label="退款金额"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="paymentTime"
        label="退款时间"
        align="center"
        show-overflow-tooltip
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="thirdparty"
        label="交易单号"
        align="center"
        show-overflow-tooltip
        width="150"
      >
      </el-table-column>
      <el-table-column
        prop="RefundType"
        label="退款来源"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="payType"
        label="退款方式"
        align="center"
        show-overflow-tooltip
      >
      </el-table-column>
      <el-table-column
        prop="TypeStatus"
        label="状态"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag type="success" v-if="scope.row.TypeStatus == '1'"
            >待审核</el-tag
          >
          <el-tag type="danger" v-else-if="scope.row.TypeStatus == '2'"
            >已退款</el-tag
          >
          <el-tag type="warning" v-else-if="scope.row.TypeStatus == '0'"
            >已驳回
          </el-tag>
          <el-tag type="info" v-else>未定义</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            @click="lookDetail(scope.row)"
            type="primary"
            style="padding: 2px 3px"
            v-if="buttonVisibility.view"
            plain
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <pagination
      :allPage="allPage"
      :pageSize="pageSize"
      :currIndex="currPage"
      @hanSiChange="hanSiChange"
      @hanCurrChange="hanCurrChange"
    ></pagination>
  </div>
</template>

<script>
import { mapState } from 'vuex';
export default {
  name: "refundRequest",
  data() {
    return {
      // {
      //   name:"姓名",
      //   contact:"联系方式",
      //   company:"公司",
      //   orderNum:"订单号",
      //   refund:"退款金额",
      //   data:"日期",
      //   time:"时间",
      //   status:"状态"
      // }
      tableData: [],
      options: [
        { value: "99", label: "全部" },
        { value: "0", label: "已驳回" },
        { value: "1", label: "待审核" },
        { value: "2", label: "已退款" },
      ],
      /**分页数据 */
      currPage: 1,
      pageSize: 20,
      allPage: 0,
      /**搜索表单 */
      searchForm: {
        status: "99",
        name: "",
      },
    };
  },
  computed: {
    ...mapState(['buttonPermissions']),
    // 按钮权限
    buttonVisibility() {
      const buttonsLimit = this.buttonPermissions?.['退款申请'] || [] ;
      return {
        export: buttonsLimit.includes('导出退货单'),
        search: buttonsLimit.includes('搜索'),
        view: buttonsLimit.includes('查看'),
      }
    }
  },
  mounted() {
    this.searchForm.status = "1";
    this.getTableData();
  },
  activated() {
    // 从缓存中获取是否存在订单查询条件(从首页传来)
    let keyword = window.sessionStorage.getItem("keyword");

    if (keyword) {
      window.sessionStorage.removeItem("keyword");
      this.searchForm.status = "1";
      // 状态转换
      // let arr = [
      //   {
      //     value: "0",
      //     label: "待退款",
      //   },
      // ];
      // for (let i = 0; i < arr.length; i++) {
      //   if (arr[i].label == keyword) {
      //     this.searchForm.status = arr[i].value;
      //     break;
      //   }
      // }
      let timer = setTimeout(() => {
        this.getTableData();
        clearTimeout(timer);
        timer = null;
      }, 200);
    }
  },
  methods: {
    updata() {
      this.getTableData();
    },
    seach() {
      this.getTableData(1);
    },
    /**获取表格数据 */
    getTableData(num) {
      this.currPage = num == 1 ? 1 : this.currPage;
      let data = {
        type: "Returnmoneys",
        status: this.searchForm.status,
        strwhere: this.searchForm.name,
        PageIndex: this.currPage,
        PageSize: this.pageSize,
      };
      let proc = "proc_OrderQuery"; //存储过程名
      let type = "ReturnList";
      this.$requestSys({
        method: "post",
        url:
          "goods/ashx/ReturnJson.ashx?type=" +
          type +
          "&json=" +
          encodeURIComponent(JSON.stringify(data)) +
          "&proc=" +
          proc,
        dataType: "json",
      })
        .then((res) => {
          this.tableData = [];
          this.allPage = 0;
          if (res.flag == 0) {
            this.tableData = res.data;
            this.allPage = res.recordCount;
          }
        })
        .catch((err) => {
          window.console.log(err);
        });
    },
    // 查看详细信息
    lookDetail(row) {
      let parms = null;
      let parmser = {
        lsh: row.Lsh,
        source: row.source,
        Amount: row.Amount,
      };
      parms = JSON.stringify(parmser);
      this.$router.push({
        path: "RefundRequestDetail",
        query: {
          row: parms,
        },
      });
      parms = null;
    },
    /**刷新表格数据 */
    handleRefresh() {
      this.getTableData();
    },
    /**分页size改变 */
    hanSiChange(val) {
      this.pageSize = val;
      this.getTableData();
    },
    /**当前页改变 */
    hanCurrChange(val) {
      this.currPage = val;
      this.getTableData();
    },
    /**点击导出 */
    handleExport() {
      let startDate = "";
      let endDate = "";
      let status = this.searchForm.status;
      let txtStrWhere = this.searchForm.name;
      let userId = window.localStorage.getItem("userId");
      let entId = window.localStorage.getItem("entId");
      window.location.href =
        this.baseUrl +
        "ToExcel/ToExceRefundOrderList?startDate=" +
        startDate +
        "&endDate=" +
        endDate +
        "&status=" +
        status +
        "&strWhere=" +
        txtStrWhere +
        "&userId=" +
        userId +
        "&entId=" +
        entId;

      // let data = {
      //   type: "Returnmoneys",
      //   status: this.searchForm.status,
      //   strwhere: this.searchForm.name,
      //   PageIndex: this.currPage,
      //   PageSize: this.pageSize,
      // };

      // let proc = "proc_OrderQuery"; //存储过程名
      // window.location.href =
      //   this.baseUrl +
      //   "Order/NoPIGExprot?json=" +
      //   encodeURIComponent(JSON.stringify(data)) +
      //   "&proc=" +
      //   encodeURIComponent(proc) +
      //   "&name=退款单申请";
    },
  },
};
</script>

<style scoped>
.refundRequest {
  width: 100%;
  height: 100%;
}
</style>
